import { Subtitle, Title } from '@tremor/react';

export function Benefits() {
  const li = 'mb-2 text-base leading-6 font-normal text-gray-700';
  return (
    <>
      <Title className="font-bold mb-3 text-2xl">Subscription Details</Title>
      <Subtitle className="text-lg rounded-xl text-[rgb(55 65 81)] my-0.5">
        This oganization does not have an active subscription
      </Subtitle>
      <section className="bg-[rgb(248,249,250)] rounded-xl mr-8 p-4 mt-6">
        <Subtitle className="text-lg text-[rgb(55,65,81)] mt-0.5 mb-2 font-bold">
          Premium Features
        </Subtitle>
        <ul className="list-disc ml-6 my-0.5 text-gray-700">
          <li className={li}>Advanced analytics and reporting</li>
          <li className={li}>Custom reports</li>
          <li className={li}>Priority Support</li>
        </ul>
      </section>
    </>
  );
}
